import { __rest } from "tslib";
import React from 'react';
import BaseFloatingElement from '@cmpkit/base-floating';
import { useClick, useDismiss, useFocus, useHover, useInteractions as floatingUiUseInteractions, } from '@floating-ui/react';
function _Popover(_a, ref) {
    var { children, placement, content, enableDismiss = true, trigger = ['click'] } = _a, props = __rest(_a, ["children", "placement", "content", "enableDismiss", "trigger"]);
    const useInteractions = (context) => floatingUiUseInteractions([
        useClick(context, {
            enabled: trigger.includes('click'),
        }),
        useHover(context, {
            enabled: trigger.includes('hover'),
        }),
        useFocus(context, { enabled: trigger.includes('focus') }),
        useDismiss(context, {
            enabled: enableDismiss,
        }),
    ]);
    const buildContextAriaAttributes = ({ floating: { id, open }, }) => ({
        'aria-haspopup': children.props['aria-haspopup'] || 'dialog',
        'aria-controls': open ? id : undefined,
    });
    const buildFloatingElementAriaAttributes = ({ ref: { id }, }) => ({
        'aria-labelledby': id,
        'aria-describedby': undefined,
    });
    return (React.createElement(BaseFloatingElement, Object.assign({ ref: ref, placement: placement, path: 'popover', useInteractions: useInteractions, buildRefElAriaAttributes: buildContextAriaAttributes, buildFloatingElAriaAttributes: buildFloatingElementAriaAttributes, content: content }, props), children));
}
const Popover = React.forwardRef(_Popover);
export default Popover;
//# sourceMappingURL=Popover.js.map